import $ from 'jquery';
import global from './global';
import marquee from './marquee';
import './index.css';

layui.use(['carousel', 'element'], function () {
    // 当窗体大小发生改变
    $(window).on('resize', () => {
        // 调整banner图高度
        const bannerEl = $('.index-banner').eq(0);
        bannerEl.height(bannerEl.width() / 1200 * 300); // 将banner的高度按banner图片的比例调整高度
    })

    // banner图
    const carousel = layui.carousel;
    carousel.render({
        elem: '#index-banner',
        width: '100%', //设置容器宽度
        // height: 'auto',
        arrow: 'hover', //始终显示箭头
        indicator: 'none', // 指示器位置
        // autoplay: false, // 自动播放
        interval: 3000, // 自动切换的时间间隔，单位：ms（毫秒），不能低于 800
    });

    const bannerEl = $('.index-banner').eq(0);
    bannerEl.height(bannerEl.width() / 1200 * 300); // 将banner的高度按banner图片的比例调整高度


    // 新闻banner
    carousel.render({
        elem: '#index-news-banner',
        width: '100%', //设置容器宽度
        height: '100%', // 高度
        anim: 'fade', // 显示方式
        arrow: 'none', //始终显示箭头
        indicator: 'inside', // 指示器位置
    });

    // 公司场景
    marquee.render({
        elem: '#index-company-scene',
        speed: 100,
        direction: 'horizantal',
    });
});